import { FunctionComponent } from "react";

import { Box } from "@chakra-ui/react";
import { IconHeadset, IconFileInfo, IconUsersGroup } from "@tabler/icons-react";
import { NavItem } from "am-tax-fe-core";
import { useTranslation } from "react-i18next";

interface Props {
    showAdmin: boolean;
    showInternalDocs: boolean;
    expanded: boolean;
}

const NavFooter: FunctionComponent<Props> = ({ showAdmin, showInternalDocs, expanded }: Props) => {
    const { t } = useTranslation("LeftNav");
    return (
        <Box>
            <NavItem
                show={true}
                to={"/feedback"}
                leftIcon={<IconHeadset />}
                text="Feedback"
                itemKey={"feedback"}
                isExpanded={expanded}
                activeColor={"aqua.500"}
            />
            <NavItem
                show={showInternalDocs}
                target="_blank"
                to="https://itinfoalvarezandmarsal.sharepoint.com/sites/TAXAND/TaxTechnology/Shared%20Documents/engage"
                leftIcon={<IconFileInfo />}
                text="Documentation"
                itemKey={"docs"}
                isExpanded={expanded}
                activeColor={"aqua.500"}
                isExternal={true}
            />
            <NavItem
                show={showAdmin}
                to={"/admin"}
                leftIcon={<IconUsersGroup />}
                text={expanded ? t("adminDashboard") : ""}
                itemKey={"admin"}
                isExpanded={expanded}
                activeColor={"aqua.500"}
            />
        </Box>
    );
};

export default NavFooter;
